export default class ExcelImportModalCtrl{

  constructor($uibModalInstance){
    this.dialog = $uibModalInstance;
    this.reset();
  }

  update(){
    this.table = [];
    this.parse(this.raw).forEach(row => {
      this.table.push({
        material_nazov: row[0],
        jednotka: row[1],
        mnozstvo: parseInt((""+row[2]).replace(/\s+/g,"").replace(",","."))
      })
    })
  }

  reset(){
    this.raw="";
    this.table = [];
  }

  parse(text) {
    var toReturn = [];
    try {
        var rows = text.split(/[\n\f\r]/);
        rows.forEach(function (thisRow) {
            var row = thisRow.trim();
            if (row != '') {
                var cols = row.split("\t");
                toReturn.push(cols);
            }
        });

    }
    catch (err) {
        console.log('error parsing as tabular data');
        console.log(err);
        return null;
    }
    return toReturn;
  }

  ok(){
    this.dialog.close(this.table);
  }

  cancel(){
    this.dialog.dismiss('cancel')
  }


}


// WEBPACK FOOTER //
// ./src/util/ExcelImportModalCtrl.js